import React from 'react';
import UserAvatar from "Components/UserAvatar";
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useAppSelector } from 'hooks/index';
import { selectUserData } from 'store/user/userSelector';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { useOrgNavigate } from "app/routes/useOrgNavigate";
import { appRoutes } from '@/routes/constants';
import useAuthLogout from 'hooks/useAuthLogout';

interface AvatarMenuProp {
    anchorEl: HTMLElement;
    setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement>>;
}

const AvatarMenu: React.FC<AvatarMenuProp> = ({ anchorEl, setAnchorEl }) => {
    const open = Boolean(anchorEl);

    const { photoURL, name: userName, email } = useAppSelector(selectUserData);
    const logout = useAuthLogout();
    const navigate = useOrgNavigate();

    const handleProfileSettings = () => {
        navigate(appRoutes.OPERATOR_PROFILE);
    };

    const handleMenuClose = (): void => {
        setAnchorEl(null);
    };

    return (
        <Menu
            open={open}
            anchorEl={anchorEl}
            onClose={handleMenuClose}
            onClick={handleMenuClose}
            MenuListProps={{
                sx: {
                    padding: 3,
                },
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <Stack gap={1}>
                <Stack
                    direction="row"
                    spacing={2}
                    padding={({ spacing }) =>
                        `${spacing(0)} ${spacing(1)} ${spacing(1)}`
                    }
                >
                    <UserAvatar src={photoURL} alt={userName} />
                    <Box>
                        <Typography variant="body1">{userName}</Typography>
                        <Typography
                            variant="body2"
                            color={(theme) => theme.palette.text.secondary}
                        >
                            {email}
                        </Typography>
                    </Box>
                </Stack>
                <Divider />
                <Box>
                    <MenuItem onClick={handleProfileSettings}>
                        <ListItemIcon>
                            <AccountCircleIcon />
                        </ListItemIcon>
                        <ListItemText>My Profile Settings</ListItemText>
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={logout}>
                        <ListItemIcon>
                            <LogoutIcon />
                        </ListItemIcon>
                        <ListItemText>Logout</ListItemText>
                    </MenuItem>
                </Box>
            </Stack>
        </Menu>
    );
};

export default AvatarMenu;
